import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {ClauseService} from '../core/ecv-http-services/services/clause.service';
import {IPageableContent} from '../shared/pageable-content';
import {CustomValidators} from '../core/validator/custom-validators';
import {ExpertFilterModel} from './expert-filter.model';
import {ExpertModel} from './expert.model';
import {ValidatorService} from '../core/validator/validator.service';


@Component({
  selector: 'app-clauses',
  templateUrl: './process-clauses.component.html',
  styleUrls: ['process-clauses.component.scss']
})
export class ProcessClausesComponent implements OnInit {
  isDesc = true;
  sort = 'projectAllocations';
  pageNumber = 0;
  pageSize = 7;
  experts: IPageableContent<ExpertModel>;
  filterModel: ExpertFilterModel;
  lastRequestedFilterModel: ExpertFilterModel;
  filterForm: FormGroup;
  filterPending: boolean;

  constructor(private clauseService: ClauseService,
              private spinnerService: Ng4LoadingSpinnerService,
              private validatorService: ValidatorService) {
    this.filterModel = new ExpertFilterModel();
    this.lastRequestedFilterModel = new ExpertFilterModel();
    this.filterPending = false;
  }

  ngOnInit() {
    this.createForm();
    this.loadExperts(this.lastRequestedFilterModel);
  }

  private createForm(): void {
    this.filterForm = new FormGroup({
      'email': new FormControl('', CustomValidators.validateNotEmptyEmail),
      'firstName': new FormControl('', CustomValidators.validateName),
      'lastName': new FormControl('', CustomValidators.validateName),
      'source': new FormControl(''),
      'id': new FormControl('', CustomValidators.validateIdentificatorNumber()),
      'hasFilttrAccount': new FormControl(''),
      'contractSigned': new FormControl('')
    });
  }

  loadExperts(filterModel: ExpertFilterModel) {
    if (this.filterPending) {
      return;
    }
    this.filterPending = true;
    const sortOrder = this.sort + ',' + (this.isDesc ? 'desc' : 'asc');
    this.spinnerService.show();
    this.clauseService.getAllExpertsNeedingProcess(filterModel, this.pageNumber, this.pageSize, sortOrder).subscribe(
      response => {
        Object.assign(this.lastRequestedFilterModel, filterModel);
        this.experts = response;
        this.filterPending = false;
        this.spinnerService.hide();
      },
      (err) => {
        this.filterPending = false;
        this.spinnerService.hide();
      });
  }

  sortTable(key: string) {
    if (this.sort === key) {
      this.isDesc = !this.isDesc;
    } else {
      this.sort = key;
    }
    this.loadExperts(this.lastRequestedFilterModel);
  }

  movePages(increment: number) {
    this.pageNumber += increment;
    this.loadExperts(this.lastRequestedFilterModel);
  }

  process(id: string) {
    window.open('/user-clauses/' + id, '_blank');
  }

  clearFilters() {
    this.filterModel = new ExpertFilterModel();
  }

  updateFilters() {
    this.validatorService.validate(this.filterForm);
    if (!this.validatorService.isValid(this.filterForm)) {
      return;
    }
    this.loadExperts(this.filterModel);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/clause/process-clauses.component.ts